import React from 'react';
import {
  Message,
  Segment,
} from 'semantic-ui-react';

const Intro = () => (
  <Segment padded>
    <Message
      header="Contract Preview"
      icon="book"
      content="The following is a preview of the contract. The information below has been generated from information you've entered in the previous steps. If any of the information is incorrect, make sure you've saved your changes."
      size="large"
    />
  </Segment>
);

export default Intro;
